module.exports = __webpack_public_path__ + "img/chapel_small.2539dde4.png";